<div class="modal-header">
    <h4 class="modal-title">Immunization</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="card-body p-0">

            <div class="table-responsive">
                <table datatable *ngIf="dtRender" class="table table-striped table-bordered table-sm" style="width:100%;">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Patient Name</th>
                            <th>vaccine Type</th>
                            <th>vaccine Code</th>
                            <th>Visit Date</th>
                            <th class="singleLine" *ngIf="!careContextHide && isNDHMEnable">Link Care Context</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of immunizationList; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ item?.patient_name}}</td>
                            <td>{{ item?.immunization_type }}</td>
                            <td>{{ item?.snomed_code }}</td>
                            <td>{{ item?.visit_date | date:'dd-MM-yyyy' }}</td>
                             <td  *ngIf ="isNDHMEnable && !careContextHide && (item?.health_id == '' || item?.health_id == null)" style="text-align: center !important;">No HealthId</td>
                             <td  *ngIf ="isNDHMEnable && !careContextHide && (item?.health_id!== '' && item?.health_id!== null && item.is_carecontext_linked==true)" style="text-align: center !important; color: green;">Care Context Added</td>
                             <td  *ngIf ="isNDHMEnable && !careContextHide && (item?.health_id!== '' && item?.health_id!== null && (item.is_carecontext_linked==false || item.is_carecontext_linked==null) )"  style="text-align: center !important;"><button class="btn btn-sm btn-primary"  (click)="openLinkwithAbhaConsultation(item)">Link Care Context</button></td>
                            
                        </tr>
                       
                    </tbody>
                </table>
            </div>

    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-sm btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
</div>
